import { Resources } from 'constants/resources';

import { useState } from 'react';

import DataObject from '@mui/icons-material/DataObject';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { UserActionJsonSchema } from 'pages/UserActions/components/UserActionJsonSchema/UserActionJsonSchema';
import { UserActionsTypeChipField } from 'pages/UserActions/components/UserActionTypeChipField/UserActionTypeChipField';
import { UserActionUserField } from 'pages/UserActions/components/UserActionUserField/UserActionUserField';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Link as RouterLink } from 'react-router-dom';
import { IconButton } from 'shared/mui/IconButtons';
import { Link } from 'shared/mui/Link/Link';
import { Datagrid } from 'shared/react-admin/Datagrids';
import { FunctionField, TextField } from 'shared/react-admin/Fields';
import { DateTimeField } from 'shared/react-admin/Fields/DateTimeField/DateTimeField';
import { ReferenceField } from 'shared/react-admin/ReferenceFields';
import { ActionsSlots } from 'shared/react-admin/Table/ActionsSlots/ActionsSlots';
import { UserAction } from 'types/embedded/userAction';

import { UserActionsListFilter } from './UserActionsListFilter/UserActionsListFilter';

export const UserActionsListContent: React.FC = () => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const translate = useTypedTranslate();

  const [currentRecord, setCurrentRecord] = useState<UserAction>();
  const [open, setOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState<UserAction>();

  return (
    <>
      <UserActionJsonSchema
        onClose={() => {
          setOpen(false);
          setCurrentRecord(undefined);
        }}
        open={open}
        record={currentRecord}
      />
      <UserActionsListFilter selectedAction={selectedAction} />
      <Datagrid
        bulkActionButtons={false}
        sx={{
          '.MuiTableCell-head': { zIndex: 9 },
          '.MuiTableCell-root': { verticalAlign: 'top' },
        }}
      >
        <FunctionField
          label="ID"
          render={(record: UserAction) => (
            <Link
              component={RouterLink}
              sx={{ textDecoration: 'none', color: 'primary.main' }}
              to={createPathWithQuery({
                resource: Resources.UserActions,
                id: record.id,
                type: 'show',
              })}
            >
              {record?.originId}
            </Link>
          )}
          sortBy="id"
        />
        <DateTimeField
          label={translate('app.table.updatedAt')}
          sortable={false}
          source="createdAt"
        />
        <TextField
          label={translate('app.table.entity')}
          sortable={false}
          source="translatedEntityName"
        />
        <FunctionField
          label={translate('app.table.entityId')}
          render={(record: UserAction) => {
            return (
              <Link
                onClick={() => setSelectedAction(record)}
                sx={{ cursor: 'pointer' }}
                underline="none"
              >
                {record?.entityId}
              </Link>
            );
          }}
          sortable={false}
        />
        <UserActionUserField label={translate('app.table.user')} />
        <TextField label={translate('app.table.ip')} sortable={false} source="ip" />
        <ReferenceField
          label={translate('app.table.eventType')}
          reference="user_event_types"
          sortable={false}
          source="eventType"
        >
          <UserActionsTypeChipField source="description" />
        </ReferenceField>
        <ActionsSlots
          render={(record: UserAction) => (
            <IconButton
              onClick={() => {
                setOpen(true);
                setCurrentRecord(record);
              }}
            >
              <DataObject />
            </IconButton>
          )}
        />
      </Datagrid>
    </>
  );
};
